<template>
<div class="info">
	<Form :label-width="120" class="mt15">
	    <FormItem label="订单号：" class="w600">
	        {{info.orderNo}}
	    </FormItem>
	    <FormItem label="订单状态：" class="w600">
	        {{info.statusName}}
	    </FormItem>
	    <FormItem label="订单创建时间：" class="w600">
	        {{info.createTime}}
	    </FormItem>
		<div v-if="info.status==2||info.status==11">
			<FormItem label="订单总额：" class="w600">
				<span class="price">{{info.orderAmount}} 元</span>
			</FormItem>
			<FormItem label="实付金额：" class="w600">
				<span class="price">{{info.amount}} 元</span>
			</FormItem>
			<FormItem label="支付方式：" class="w600">
				{{info.payTypeName}}
			</FormItem>
			<FormItem label="支付时间：" class="w600">
				{{info.paymentTime}}
			</FormItem>
			<FormItem label="保障凭证号：" class="w600">
				{{info.policyVoucherNo}}
			</FormItem>
		</div>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info:Object,
	},
}
</script>
<style scoped>
	span.price{
		color:red;
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/OrderBasicInfo.vue